import { Navigate, Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";

const HomeLitePage = lazy(() => import("@/pages/lite-home-page"));

import { routes } from "@/common/utils/routes";
import { Loader } from "@rg/ui/components/Loader";
import { WithTimer } from "@/components/UI/WithTimer";

export const RoutesComponents = () => {
  return (
    <Suspense fallback={<WithTimer waitTime={2000}><Loader /></WithTimer>}>
      <Routes>
        <Route path={routes.home()} element={<HomeLitePage />} />
        {/* Prevent partytown issue with requested wrong page in Firefox */}
        <Route path={routes.partyTown()} element={<></>} />

        <Route path="*" element={<Navigate to={routes.home()} />} />
      </Routes>
    </Suspense>
  );
};
